// CRM lead Text opens the handset SMS app. It does not navigate to Tools /phone.
// First text keeps the pre-SLED-097 floor script; later texts open a blank message.

export function handsetSmsUrl({ phone, leadName, car = {}, userName, smsCount } = {}) {
  if (!phone) return null;
  let smsUrl = `sms:${phone}`;
  const count = Number(smsCount);
  if (Number.isFinite(count) && count > 0) return smsUrl;

  const firstName = String(leadName || '').split(' ')[0] || '';
  const who = userName || 'the Sales Team';
  const year = (car && car.year) || '';
  const make = (car && car.make) || '';
  const model = (car && car.model) || 'vehicle';
  const template = `Hi ${firstName || 'there'}, this is ${who} from Skyway Classics. Thanks for reaching out about our ${year} ${make} ${model}. Yes it is still available. How can I help you with the vehicle?`;
  return `${smsUrl}?body=${encodeURIComponent(template)}`;
}
